export default __webpack_public_path__ + "static/media/img-soon-7.88172631.svg";